module.exports = __webpack_public_path__ + "img/w4_05.a9f639ad.jpg";